import { useLazyGetLoginStatusQuery } from '@/api';
import { useEffect, useRef } from 'react';

const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

export const useCheckLoginStatus = () => {
  const [triggerGetLoginStatus] = useLazyGetLoginStatusQuery();
  const intervalRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    triggerGetLoginStatus({});

    intervalRef.current = setInterval(() => {
      triggerGetLoginStatus({});
    }, CHECK_INTERVAL_MS);

    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [triggerGetLoginStatus]);
};
